import EventBus from '@/eventBus'

/**
 * Slide Content Sync Module
 * Handles EventBus emissions for specific slide types to keep components in sync
 */

const SUPPORTED_SLIDE_TYPES = {
  MATCH_PAIRS: 'matchPairs',
  CORRECT_ORDER: 'correctOrder',
  TYPE_ANSWER: 'typeAnswer',
  SCALE: 'scale',
  SPINNER_WHEEL: 'spinnerWheel',
}

const SLIDE_EVENTS = {
  [SUPPORTED_SLIDE_TYPES.MATCH_PAIRS]: ['match-pairs-change'],
  [SUPPORTED_SLIDE_TYPES.CORRECT_ORDER]: ['correct-order-changes', 'update-correct-order-canvas-content'],
  [SUPPORTED_SLIDE_TYPES.TYPE_ANSWER]: ['eventShowQuizTypeAnswer'],
  [SUPPORTED_SLIDE_TYPES.SCALE]: ['reloadScaleChart'],
  [SUPPORTED_SLIDE_TYPES.SPINNER_WHEEL]: ['refreshSpinnerWheelEntries'],
}

const state = {
  // No state needed - this module only handles side effects
}

const mutations = {
  // No mutations needed - this module only handles side effects
}

const actions = {
  /**
   * Emit content sync events for supported slide types
   * This is called when slides are activated or content changes
   */
  emitSlideContentSyncEvents(context, payload) {
    // Handle null/undefined payload gracefully
    if (!payload || typeof payload !== 'object') {
      return
    }

    const { slideType } = payload

    const events = SLIDE_EVENTS[slideType]
    if (events) {
      events.forEach((event) => {
        EventBus.$emit(event)
      })
    }
  },

  /**
   * Handle slide activation - emit sync events for supported slide types
   */
  handleSlideContentChange({ dispatch }, slide) {
    const slideType = slide?.slideType || slide?.type
    dispatch('emitSlideContentSyncEvents', {
      slideType,
    })
  },
}

const getters = {
  // No getters needed - this module only handles side effects
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
